import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import selectAllProps from './selectors';
import * as userActions from '../../actions/userAction';
import UserList from '../../components/UserList';
import MyLoader from '../../components/MyLoader';

class UserContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentWillMount() {
        this.props.userActions.getAllRoles();
        this.props.userActions.getAllUsers();
    }

    componentWillReceiveProps(nextProps) {
    }

    render() {
        if (this.props.loading) return (<MyLoader/>);
        return (
            <div>
                <UserList />
                {this.props.children}
            </div>
        );
    }
}

UserContainer.propTypes = {
    users: PropTypes.array,
    userActions: PropTypes.object,
    loading: PropTypes.bool,
    children: PropTypes.node
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserContainer);


/** WEBPACK FOOTER **
 ** ./src/container/UserContainer/index.js
 **/